import React, { createContext, useCallback, useState } from 'react';
import { useDisclosure } from '@mantine/hooks';

import PDFViewer from '../components/features/PDFViewer';

interface PdfParams {
  fileUrl: string;
  initialPage?: number;
  fileName?: string;
}

interface PDFViewerContextValue {
  open: (params: PdfParams) => void;
  close: () => void;
}

export const PDFViewerContext = createContext<PDFViewerContextValue | undefined>(undefined);

export function PDFViewerProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, { open: openModal, close: closeModal }] = useDisclosure(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [initialPage, setInitialPage] = useState<number>(1);
  const [fileName, setFileName] = useState<string>('Document');

  const open = useCallback(
    ({ fileUrl, initialPage = 1, fileName = 'Document' }: PdfParams) => {
      setFileUrl(fileUrl);
      setInitialPage(initialPage);
      setFileName(fileName);
      openModal();
    },
    [openModal]
  );

  const close = useCallback(() => {
    setFileUrl(null);
    setInitialPage(1);
    setFileName('Document');
    closeModal();
  }, [closeModal]);

  return (
    <PDFViewerContext.Provider value={{ open, close }}>
      {children}
      <PDFViewer fileUrl={fileUrl} isOpen={isOpen} onClose={close} initialPage={initialPage} fileName={fileName} />
    </PDFViewerContext.Provider>
  );
}
